interface Props {
  cardName?: string;
  cardCost?: number;
  cardDescription?: string;
  /** the card type's risk and reward, one line */
  cardRisk?: string;
  targetLabel?: string;
  canPlay: boolean;
  disabledReason: string;
  onPlay: () => void;
  onEndScene: () => void;
}

export function PlayCardBar({
  cardName,
  cardCost,
  cardDescription,
  cardRisk,
  targetLabel,
  canPlay,
  disabledReason,
  onPlay,
  onEndScene,
}: Props) {
  return (
    <div className={`play-card-bar ${cardName ? '' : 'play-card-bar--idle'}`} role="region" aria-label="Play card">
      <div className="play-card-preview">
        {cardName ? (
          <>
            <p className="play-card-preview__title">
              {cardName}
              <span className="play-card-preview__cost">{cardCost} Ink</span>
            </p>
            {cardDescription && <p className="play-card-preview__desc">{cardDescription}</p>}
            {cardRisk && <p className="play-card-preview__risk">{cardRisk}</p>}
            {targetLabel && (
              <p className="play-card-preview__target">
                Target: <strong>{targetLabel}</strong>
              </p>
            )}
          </>
        ) : (
          <p className="play-card-preview__hint">Tap a card in your hand to preview it.</p>
        )}
      </div>
      <div className="play-card-actions">
        <button
          type="button"
          className="btn btn-play-card"
          disabled={!canPlay}
          onClick={onPlay}
          aria-describedby={!canPlay ? 'play-card-disabled-reason' : undefined}
        >
          Play card
        </button>
        {!canPlay && disabledReason && (
          <p id="play-card-disabled-reason" className="play-card-disabled-reason">
            {disabledReason}
          </p>
        )}
        <button type="button" className="btn btn-end-scene" onClick={onEndScene}>
          End scene
        </button>
      </div>
    </div>
  );
}
